<template>
  <nav class="text-slate-800 text-right text-xs px-5 py-1 bg-gray-100">
    LVM Framework 1.0 © Softwaresul 2019 - 2024
  </nav>
</template>
